import * as Yup from 'yup';

export const schema = Yup.object().shape({
  name: Yup.string()
    .required('saveForm.name.required')
    .min(2, 'saveForm.name.min')
    .max(150, 'saveForm.name.max'),
});
